import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EventHelper } from '@core/helpers/event.helper';

@Component({
  selector: 'pop-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.less']
})
export class SwitchComponent {
  @Input()
  private reversed = false;

  @Input()
  public disabled = false;

  private _isSwitched: boolean | undefined;
  @Input()
  public get isSwitched() {
    return this.reversed ? !this._isSwitched : this._isSwitched;
  }
  public set isSwitched(value: boolean | undefined) {
    this._isSwitched = value;
  }

  @Output()
  public isSwitchedChange = new EventEmitter<boolean>();

  public toggle(event: MouseEvent) {
    if (this.disabled) {
      return;
    }
    EventHelper.stopEventHere(event);
    this.isSwitched = !this.isSwitched;
    this.isSwitchedChange.emit(this.isSwitched);
  }
}
